import { CreateMagazineCategoryDto } from "../entity/magazineCategory/dto/create-category-dto";
import { magazineCategoryService } from "../entity/magazineCategory/MagazineCategoryService";

export const createMagazineCategoryUseCase = async (body: CreateMagazineCategoryDto) => {
    try {
        const filteredBody = Object.fromEntries(
            Object.entries(body).filter(([_, value]) => value !== undefined && value !== null)
        );

        const response = await magazineCategoryService.create(filteredBody);
        return response;
    } catch (error) {
        console.warn('createMagazineCategoryUseCase: ', error);
        return { isError: true, data: null, message: '' };
    }
}
